<template>
  <div class="usuarios-detalle">
    <b-card>
      <div v-if="cargando" class="text-center py-4">
        <b-spinner variant="primary" />
        <p class="mt-2">Cargando usuario...</p>
      </div>

      <div v-else-if="error" class="text-center py-4">
        <b-alert variant="danger" show>
          {{ error }}
        </b-alert>
        <b-button variant="primary" @click="cargarUsuario">
          Reintentar
        </b-button>
      </div>

      <div v-else>
        <div class="header">
          <div class="avatar" :title="nombreCompleto">
            {{ avatarIniciales }}
          </div>
          <div class="header-info">
            <div class="title-row">
              <h2 class="nombre">{{ nombreCompleto }}</h2>
              <b-badge variant="light-primary" class="ml-1" v-if="usuario.nombreRol">{{ usuario.nombreRol }}</b-badge>
            </div>
            <div class="meta">
              <span class="meta-item">
                <feather-icon icon="MailIcon" size="16" class="mr-25" />
                <a :href="`mailto:${usuario.email}`">{{ usuario.email }}</a>
              </span>
              <span class="meta-sep">•</span>
              <span class="meta-item">
                <feather-icon icon="CalendarIcon" size="16" class="mr-25" />
                {{ usuario.fechaRegistro ? new Date(usuario.fechaRegistro).toLocaleString() : '-' }}
              </span>
            </div>
          </div>
          <div class="actions">
            <b-button variant="primary" @click="irAEditar">
              <feather-icon icon="EditIcon" size="16" class="mr-25" />
              Editar
            </b-button>
            <b-button variant="outline-secondary" class="ml-50" @click="volver">
              Volver
            </b-button>
          </div>
        </div>

        <b-row class="mt-2">
          <b-col cols="12" md="6">
            <b-card class="info-card">
              <h5 class="section-title">Información básica</h5>
              <dl class="dl">
                <div class="dl-row">
                  <dt>Nombre</dt>
                  <dd>{{ usuario.nombre }}</dd>
                </div>
                <div class="dl-row">
                  <dt>Primer apellido</dt>
                  <dd>{{ usuario.primerApellido }}</dd>
                </div>
                <div class="dl-row" v-if="usuario.segundoApellido">
                  <dt>Segundo apellido</dt>
                  <dd>{{ usuario.segundoApellido }}</dd>
                </div>
              </dl>
            </b-card>
          </b-col>
          <b-col cols="12" md="6">
            <b-card class="info-card">
              <h5 class="section-title">Cuenta</h5>
              <dl class="dl">
                <div class="dl-row">
                  <dt>Email</dt>
                  <dd><a :href="`mailto:${usuario.email}`">{{ usuario.email }}</a></dd>
                </div>
                <div class="dl-row">
                  <dt>Rol</dt>
                  <dd>
                    <b-badge variant="light-primary">{{ usuario.nombreRol || `Rol #${usuario.idRol}` }}</b-badge>
                  </dd>
                </div>
                <div class="dl-row">
                  <dt>Fecha registro</dt>
                  <dd>{{ usuario.fechaRegistro ? new Date(usuario.fechaRegistro).toLocaleString() : '-' }}</dd>
                </div>
              </dl>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
  
</template>

<script>
import usuarioService from '@/services/usuarioService'

export default {
  name: 'UsuariosDetalle',
  data() {
    return {
      usuario: null,
      cargando: false,
      error: null,
    }
  },
  computed: {
    nombreCompleto() {
      if (!this.usuario) return ''
      const { nombre, primerApellido, segundoApellido } = this.usuario
      return `${nombre} ${primerApellido} ${segundoApellido || ''}`.trim()
    },
    avatarIniciales() {
      if (!this.usuario) return ''
      const n = (this.usuario.nombre || '').charAt(0)
      const a = (this.usuario.primerApellido || '').charAt(0)
      return `${n}${a}`.toUpperCase()
    },
    idUsuario() {
      return Number(this.$route.params.id)
    }
  },
  async mounted() {
    await this.cargarUsuario()
  },
  methods: {
    async cargarUsuario() {
      this.cargando = true
      this.error = null
      try {
        this.usuario = await usuarioService.getUsuarioById(this.idUsuario)
      } catch (e) {
        this.error = 'No se pudo cargar el usuario'
      } finally {
        this.cargando = false
      }
    },
    irAEditar() {
      this.$router.push({ name: 'usuarios-editar', params: { id: this.idUsuario } })
    },
    volver() {
      this.$router.push({ name: 'usuarios-lista' })
    }
  }
}
</script>

<style lang="scss" scoped>
.usuarios-detalle {
  padding: 1.5rem;
}

.header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eef0f2;
}

.avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #f0f4ff;
  color: #3453d1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.125rem;
}

.header-info {
  flex: 1;
  min-width: 0;
}

.title-row {
  display: flex;
  align-items: center;
  gap: .5rem;
}

.nombre {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: #2c3e50;
}

.meta {
  margin-top: .25rem;
  color: #6c757d;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: .5rem;
}

.meta-item {
  display: inline-flex;
  align-items: center;
}

.meta-sep {
  color: #c0c4c9;
}

.actions {
  display: flex;
  align-items: center;
}

.info-card {
  height: 100%;
}

.section-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: .75rem;
  color: #34495e;
}

.dl {
  margin: 0;
}

.dl-row {
  display: grid;
  grid-template-columns: 160px 1fr;
  gap: .5rem 1rem;
  padding: .5rem 0;
  border-bottom: 1px dashed #edf0f3;
}

.dl-row:last-child {
  border-bottom: 0;
}

dt {
  margin: 0;
  color: #6b7280;
}

dd {
  margin: 0;
  color: #2c3e50;
  font-weight: 500;
}
</style>


